module.exports = __webpack_public_path__ + "img/icononboardingkendala.76a70f4c.svg";